import React from "react";
import { Link } from "react-router-dom";
import { formatBlogDate } from "../data/blogPosts";

function BlogPostCard({ post, imageBase }) {
  const img = `${imageBase}/${post.featuredImage}`;
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm ring-1 ring-slate-200/40 transition hover:border-slate-300/90 hover:shadow-md">
      <Link to={`/blog/${encodeURIComponent(post.slug)}`} className="block shrink-0">
        <div className="relative aspect-[16/10] w-full overflow-hidden bg-slate-100">
          <img
            src={img}
            alt=""
            className="h-full w-full object-cover transition duration-300 group-hover:scale-[1.02]"
            loading="lazy"
            decoding="async"
          />
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{post.category}</p>
        <h2 className="mt-2 text-lg font-semibold leading-snug tracking-tight text-slate-900">
          <Link
            to={`/blog/${encodeURIComponent(post.slug)}`}
            className="transition hover:text-slate-700"
          >
            {post.title}
          </Link>
        </h2>
        <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-slate-600">{post.excerpt}</p>
        <div className="mt-4 flex items-center justify-between gap-2 border-t border-slate-100 pt-3 text-xs text-slate-500">
          <time dateTime={post.date}>{formatBlogDate(post.date)}</time>
          <span>{post.readTime}</span>
        </div>
      </div>
    </article>
  );
}

export default BlogPostCard;
